import './style.css'

export function Banner({ title, subtitle, backgroundImage }) {
  return (
    <section className="banner" style={{ backgroundImage: `${backgroundImage}` }}>
      <div className="banner-overlay">
        <div className="banner-content">
          <h1 className="banner-title">{title}</h1>
          <p className="banner-subtitle">{subtitle}</p>
        </div>
      </div>
    </section>
  )
}
